import PictureInPicture from './PictureInPicture'

export default PictureInPicture
// eslint-disable-next-line import/export
export * from './PictureInPicture'
